export const TeamcardLinkageRoutes = {
    ROOT: "/teamcard-linkage",
    EMAIL: "/teamcard-linkage/email",
    SIGNING: "/teamcard-linkage/signing",
    SUCCESS: "/teamcard-linkage/success",
    SMS_VERIFICATION: "/teamcard-linkage/match-success",
    MATCH_ERROR: "/teamcard-linkage/match-error",
    PDF: "/teamcard-linkage/pdf",
};



// WEBPACK FOOTER //
// ./src/components/teamcardLinkage/TeamcardLinkageRoutes.ts